export const CUSTOMER_STATUS = {
  linked: { label: 'Linked', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  differs: { label: 'Details differ', cls: 'bg-amber-50 text-amber-800 border-amber-200' },
  aiq_only: { label: 'Only in AccountsIQ', cls: 'bg-sky-50 text-sky-800 border-sky-200' },
  not_in_aiq: { label: 'Code not found', cls: 'bg-red-50 text-red-700 border-red-200' },
  no_code: { label: 'No code', cls: 'bg-zinc-100 text-zinc-700 border-zinc-200' },
  ignored: { label: 'Ignored', cls: 'bg-zinc-50 text-zinc-500 border-zinc-200' },
};

export const PRODUCT_STATUS = {
  in_sync: { label: 'In sync', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  differs: { label: 'Differs — decide', cls: 'bg-amber-50 text-amber-800 border-amber-200' },
  aiq_only: { label: 'Only in AccountsIQ', cls: 'bg-sky-50 text-sky-800 border-sky-200' },
  not_in_aiq: { label: 'Not in AccountsIQ', cls: 'bg-red-50 text-red-700 border-red-200' },
  no_code: { label: 'No code', cls: 'bg-zinc-100 text-zinc-700 border-zinc-200' },
  ignored: { label: 'Ignored', cls: 'bg-zinc-50 text-zinc-500 border-zinc-200' },
};

export const BASIS_OPTIONS = [
  { value: 'kg', label: 'Per kg' },
  { value: 'units', label: 'Per unit' },
  { value: 'cases', label: 'Per case' },
];

export const BASIS_UNIT = { kg: 'kg', units: 'units', cases: 'cases' };

export const aiqSentPatch = (result) => ({
  accountsiq_invoice_id: result.invoice_id,
  accountsiq_transaction_id: String(result.invoice_id),
  accountsiq_status: result.status,
  accountsiq_pushed_at: new Date().toISOString(),
  invoice_status: 'invoiced',
  invoice_number: `AIQ draft #${result.invoice_id}`,
  invoice_raised_at: new Date().toISOString(),
  invoice_raised_by: result.sent_by,
});

export const fmt = (n, dp = 2) => (n === null || n === undefined
  ? '—'
  : Number(n).toLocaleString('en-IE', { minimumFractionDigits: dp, maximumFractionDigits: dp }));

export const money = (n, currency) => (n === null || n === undefined ? '—' : `${currency || 'EUR'} ${fmt(n, 2)}`);

export const errMsg = (e, fallback) => {
  const detail = e?.response?.data?.detail;
  return typeof detail === 'string' ? detail : fallback;
};

export const when = (iso) => (iso ? new Date(iso).toLocaleString('en-IE') : 'never');
